import { Task } from '../../types';

type AssignedProfile = {
    id: string;
    full_name?: string;
    avatar_url?: string;
};

/** Entidade de domínio retornada pelo repositório */
export interface DomainTaskEntity {
    id: string;
    leadId?: string | null;
    /** UUID em `tasks.assigned_to` (coluna), independente do join de profiles */
    assignedTo?: string;
    opportunity?: {
        id: string;
        title?: string;
        contacts?: { name: string; phone?: string; email?: string };
    };
    assignedToProfile?: AssignedProfile | AssignedProfile[] | null;
    getTitle(): string;
    getDueDate(): Date;
    getIsCompleted(): boolean;
    getDescription(): string;
    getType(): string;
}

function normalizeAssignedProfile(
    profile: DomainTaskEntity['assignedToProfile'],
): AssignedProfile | undefined {
    if (!profile) return undefined;
    const row = Array.isArray(profile) ? profile[0] : profile;
    if (!row?.id) return undefined;
    return row;
}

/** Resolve responsável para a UI: profile (join) ou fallback no UUID da coluna. */
export function mapAssignedToFrontend(t: DomainTaskEntity): Task['assignedTo'] {
    const profile = normalizeAssignedProfile(t.assignedToProfile);
    if (profile) {
        return {
            id: profile.id,
            name: profile.full_name?.trim() || '',
            avatar: profile.avatar_url,
        };
    }
    if (t.assignedTo) {
        return { id: t.assignedTo, name: '' };
    }
    return undefined;
}

/** Mapeia entidade de domínio para interface de frontend. */
export function mapDomainTaskToFrontend(t: DomainTaskEntity): Task {
    return {
        id: t.id,
        leadId: t.leadId,
        title: t.getTitle(),
        dueDate: t.getDueDate().toISOString(),
        isCompleted: t.getIsCompleted(),
        description: t.getDescription(),
        type: t.getType(),
        lead: t.opportunity ? {
            id: t.opportunity.id,
            name: t.opportunity.title || 'Sem título',
            contact: t.opportunity.contacts ?? undefined
        } : undefined,
        assignedTo: mapAssignedToFrontend(t),
    };
}

/** Extrai UUID do assignedTo independente do formato (string ou objeto). */
export function resolveAssignedToId(assignedTo: Task['assignedTo']): string | undefined {
    if (!assignedTo) return undefined;
    if (typeof assignedTo === 'string') return assignedTo;
    return assignedTo.id;
}
